import { z } from 'zod/v3';
import { WorkspaceRoleSchema } from '../generated/enums'

export const WorkspaceMemberUserDTOSchema = z.object({
  id: z.string(),
  name: z.string().nullable().optional(),
  email: z.string().nullable().optional(),
  image: z.string().nullable().optional(),
})

export const WorkspaceMemberDTOSchema = z.object({
  id: z.string(),
  workspaceId: z.string(),
  userId: z.string(),
  role: WorkspaceRoleSchema,
  user: WorkspaceMemberUserDTOSchema.optional(),
  createdAt: z.date(),
  updatedAt: z.date(),
})

export const AddWorkspaceMemberDTOSchema = z.object({
  userId: z.string(),
  role: WorkspaceRoleSchema.default('CONTRIBUTOR'),
})

export const UpdateWorkspaceMemberRoleDTOSchema = z.object({
  memberId: z.string(),
  role: WorkspaceRoleSchema,
})

export type WorkspaceMemberDTO = z.infer<typeof WorkspaceMemberDTOSchema>
export type AddWorkspaceMemberDTO = z.infer<typeof AddWorkspaceMemberDTOSchema>
export type UpdateWorkspaceMemberRoleDTO = z.infer<typeof UpdateWorkspaceMemberRoleDTOSchema>

export const ListUnifiedWorkspaceMembersDTOSchema = z.object({
  limit: z.number().min(1).max(50).default(20),
  cursor: z.string().optional(),
  search: z.string().optional(),
})

const UnifiedMemberUserDTOSchema = z.object({
  id: z.string(),
  name: z.string().nullable().optional(),
  email: z.string().nullable().optional(),
  image: z.string().nullable().optional(),
  emailVerified: z.boolean().optional(),
})

export const UnifiedWorkspaceMemberRowDTOSchema = z.discriminatedUnion('kind', [
  z.object({
    kind: z.literal('member'),
    id: z.string(),
    userId: z.string(),
    role: z.string(),
    status: z.literal('active'),
    date: z.date(),
    user: UnifiedMemberUserDTOSchema,
  }),
  z.object({
    kind: z.literal('invitation'),
    id: z.string(),
    email: z.string(),
    role: z.string(),
    status: z.enum(['pending', 'expired']),
    date: z.date(),
    organizationId: z.string(),
  }),
])

export const ListUnifiedWorkspaceMembersResultDTOSchema = z.object({
  items: z.array(UnifiedWorkspaceMemberRowDTOSchema),
  nextCursor: z.string().optional(),
})

export type ListUnifiedWorkspaceMembersDTO = z.infer<typeof ListUnifiedWorkspaceMembersDTOSchema>
export type UnifiedWorkspaceMemberRowDTO = z.infer<typeof UnifiedWorkspaceMemberRowDTOSchema>
export type ListUnifiedWorkspaceMembersResultDTO = z.infer<typeof ListUnifiedWorkspaceMembersResultDTOSchema>
